/* eslint-disable react-hooks/exhaustive-deps */
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useDeleteCognitoUserMutation } from "../../../../services/serverless";
import { useState } from "react";
import { useLazyTSUserDeleteQuery } from "../../../../services/gallus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

interface DeleteUserModalProps {
  selectedUser:
    | {
        username: string;
        email: string;
        preferredUsername: string;
      }
    | undefined;
  modalIsOpen: boolean;
  defaultCognitoGroup: string;
  preferredUsernameIsEmail: boolean;
  toggleModal: () => void;
}

export const DeleteUserModal = (props: DeleteUserModalProps) => {
  const [deleteCognitoUserMutation] = useDeleteCognitoUserMutation();
  const [TSUserDelete] = useLazyTSUserDeleteQuery();
  const [loading, setLoading] = useState<boolean>(false);

  const [errorMessage, setErrorMessage] = useState<string | null>();

  const handleDelete = async () => {
    try {
      if (props.selectedUser) {
        setLoading(true);
        await deleteCognitoUserMutation(props.selectedUser.username).unwrap();
        let TSUsername: string = props.selectedUser.username;
        if (props.preferredUsernameIsEmail) {
          TSUsername = props.selectedUser.preferredUsername;
        }
        await TSUserDelete({
          username: TSUsername,
          orgName: props.defaultCognitoGroup,
        });
        setLoading(false);
      }
      props.toggleModal();
    } catch (error) {
      setErrorMessage(
        `Error deleting user ${props.selectedUser}. Please try again later.`,
      );
    }
  };

  return (
    <Modal isOpen={props.modalIsOpen} toggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}>Delete User</ModalHeader>
      {loading && (
        <div
          style={{
            paddingBottom: "25px",
          }}
          className="loading-div"
        >
          <FontAwesomeIcon
            icon={faSpinner}
            size="2x"
            spin={true}
            style={{ margin: "0 auto" }}
          />
        </div>
      )}
      {!errorMessage && !loading && (
        <div>
          <ModalBody>
            Do you want to delete user {props.selectedUser?.username}?
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                handleDelete();
              }}
            >
              Yes
            </Button>
            <Button color="secondary" onClick={() => props.toggleModal()}>
              Cancel
            </Button>
          </ModalFooter>
        </div>
      )}
      {errorMessage && !loading && (
        <div>
          <ModalBody>{errorMessage}</ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => props.toggleModal()}>
              Close
            </Button>
          </ModalFooter>
        </div>
      )}
    </Modal>
  );
};
